<div class="l-modal02__contents u-modal-size-pc-600 js-modal-contents" aria-modal="true" aria-labelledby="modalTitle">
  <div class="l-modal02__header js-modal-head">
    <!-- モーダルヘッダーが入ります -->
    <div class="p-modal-head02">
      <h1 id="modalTitle" class="p-modal-head02__title">{{ 'label.shareItinerary2' | staticMsg }}</h1>
      <button class="p-modal-head02__close js-modal-close" id="close-share-modal" (click)="clickCloseShareItinerary()">
        <span class="u-visually-hidden" [innerHTML]="'label.share' | staticMsg"></span>
      </button>
    </div>
    <!-- //モーダルヘッダーが入ります -->
  </div>

  <div class="l-modal02__body js-modal-body">
    <!-- モーダルの中身が入ります -->

    <div class="p-modal-body07">
      <div class="p-modal-share-itinerary">
        <div class="p-modal-share-itinerary__item">
          <h2 class="p-modal-share-itinerary__title">
            <span class="c-text-with-tooltip">
              <span class="c-text-with-tooltip__text">{{ 'label.sendReservationInformation' | staticMsg }}</span>
            </span>
            <span class="c-text-with-tooltip__tooltip js-tooltip">
              <asw-tooltip
                iconImage="<img src=&quot;assets/images/icon_help_primary_20.svg&quot; alt={{
                  'm_static_message-alt.helpIcon2' | staticMsg
                }} width=&quot;20&quot; height=&quot;20&quot;>"
                [tooltipContent]="'tooltip.sendReservationInfo' | staticMsg"
                tooltipDisplayType="tap"
                [tooltipTop]="-65"
                [displayAreaClass]="'l-modal02__contents'"
              ></asw-tooltip>
            </span>
          </h2>
          <ul class="p-modal-share-itinerary__list">
            <li class="p-modal-share-itinerary__list-item">
              <!-- (1.7.2) 予約確認メール送信モーダル表示 -->
              <a href="javascript:void(0)" (click)="clickEmail()" class="c-next-action02" id="share-email">
                <div class="c-next-action02__body">
                  <div class="c-next-action02__title">
                    <span class="c-next-action02__icon c-next-action02__icon--has-text">
                      <img src="assets/images/icon_email_24.svg" width="24" height="24" alt="" />
                      <span
                        class="c-next-action02__icon-text c-next-action02__icon-text--em c-next-action02__icon-text--ml12"
                        [innerHTML]="'label.eMail' | staticMsg"
                      ></span>
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li class="p-modal-share-itinerary__list-item">
              <!-- (1.7.3) メッセージアプリ共有(LINE) -->
              <a
                href="javascript:void(0)"
                (click)="onHandleShareLine()"
                class="c-next-action02"
                id="share-line"
                *ngIf="deviceType === 'SP'"
              >
                <div class="c-next-action02__body">
                  <div class="c-next-action02__title">
                    <span class="c-next-action02__icon c-next-action02__icon--has-text">
                      <img src="assets/images/icon_line_24.svg" width="24" height="24" alt="" />
                      <span
                        [innerHTML]="'label.line' | staticMsg"
                        class="c-next-action02__icon-text c-next-action02__icon-text--em c-next-action02__icon-text--ml12"
                      ></span>
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li class="p-modal-share-itinerary__list-item">
              <!-- (1.7.4) メッセージアプリ共有(SMS) -->
              <a
                href="javascript:void(0)"
                (click)="onHandleShareSms()"
                class="c-next-action02"
                id="share-sms"
                *ngIf="deviceType === 'SP'"
              >
                <div class="c-next-action02__body">
                  <div class="c-next-action02__title">
                    <span class="c-next-action02__icon c-next-action02__icon--has-text">
                      <img src="assets/images/icon_sms_24.svg" width="24" height="24" alt="" />
                      <span
                        [innerHTML]="'label.sms2' | staticMsg"
                        class="c-next-action02__icon-text c-next-action02__icon-text--em c-next-action02__icon-text--ml12"
                      ></span>
                    </span>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>

        <!-- (1.7.5) カレンダー登録 -->
        <div class="p-modal-share-itinerary__item" *ngIf="isCalendarSectionShow">
          <h2 class="p-modal-share-itinerary__title">
            <span class="c-text-with-tooltip">
              <span class="c-text-with-tooltip__text">{{ 'label.addCalendar' | staticMsg }}</span>
            </span>
            <span class="c-text-with-tooltip__tooltip js-tooltip">
              <asw-tooltip
                iconImage="<img src=&quot;assets/images/icon_help_primary_20.svg&quot; alt={{
                  'm_static_message-alt.helpIcon2' | staticMsg
                }} width=&quot;20&quot; height=&quot;20&quot;>"
                [tooltipContent]="getCalendarTooltipContent()"
                tooltipDisplayType="tap"
                [tooltipTop]="0"
                [displayAreaClass]="'l-modal02__contents'"
              ></asw-tooltip>
            </span>
          </h2>
          <ul class="p-modal-share-itinerary__list">
            <li class="p-modal-share-itinerary__list-item">
              <!-- (1.7.6) Googleボタン -->
              <a href="javascript:void(0)" (click)="clickGoogleCalendar()" class="c-next-action02" id="google-calendar">
                <div class="c-next-action02__body">
                  <div class="c-next-action02__title">
                    <span class="c-next-action02__icon c-next-action02__icon--has-text">
                      <img src="assets/images/icon_calendar_24.svg" width="24" height="24" alt="" />
                      <span
                        class="c-next-action02__icon-text c-next-action02__icon-text--em c-next-action02__icon-text--ml12"
                        [innerHTML]="'label.googleCalender' | staticMsg"
                      ></span>
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li class="p-modal-share-itinerary__list-item">
              <!-- (1.7.7) Apple Calendarボタン -->
              <a href="javascript:void(0)" (click)="clickAppleCalendar()" class="c-next-action02" id="apple-calendar">
                <div class="c-next-action02__body">
                  <div class="c-next-action02__title">
                    <span class="c-next-action02__icon c-next-action02__icon--has-text">
                      <img src="assets/images/icon_calendar_24.svg" width="24" height="24" alt="" />
                      <span
                        [innerHTML]="'label.iCal' | staticMsg"
                        class="c-next-action02__icon-text c-next-action02__icon-text--em c-next-action02__icon-text--ml12"
                      ></span>
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li class="p-modal-share-itinerary__list-item">
              <!-- (1.7.8) Outlookボタン -->
              <a href="javascript:void(0)" (click)="clickOutlook()" class="c-next-action02" id="share-outlook">
                <div class="c-next-action02__body">
                  <div class="c-next-action02__title">
                    <span class="c-next-action02__icon c-next-action02__icon--has-text">
                      <img src="assets/images/icon_calendar_24.svg" width="24" height="24" alt="" />
                      <span
                        [innerHTML]="'label.outlook' | staticMsg"
                        class="c-next-action02__icon-text c-next-action02__icon-text--em c-next-action02__icon-text--ml12"
                      ></span>
                    </span>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- //モーダルの中身が入ります -->
  </div>
</div>
